import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import { ExecuteOperationOnPipe, useModel } from '@morningtrain/react-resources'
import { ResourceSelector } from 'support/fields'
import { StaticFilter } from '@morningtrain/react-filters'
import { CallbackOnPipe, Pipeline } from '@morningtrain/react-helpers'
import TriggerPipelineOnChange from 'support/pipelines/TriggerPipelineOnChange'
import RejectIfModelValue from 'support/pipelines/RejectIfModelValue'

function EmploymentTypeField () {

  const model = useModel()

  return (
    <Pipeline>
      <TriggerPipelineOnChange>
        <ResourceSelector
          name='employment_type_id'
          optionsKey='name'
          resourceName='employments.employment_type'
          label={<Translation name='fields.employment_type.label'/>}
        >
          <StaticFilter name='only_manageable' value/>
        </ResourceSelector>
      </TriggerPipelineOnChange>
      <RejectIfModelValue name='has_manual_salary_step_change'/>
      <ExecuteOperationOnPipe
        operationName='select'
        resourceName='employments.employment_type_salary_step'
        data={(payload) => {
          return {
            employment_type_id: payload.value,
          }
        }}
      />
      <CallbackOnPipe callback={(payload) => model.set('salary_steps', payload.responses.select.collection)}/>
    </Pipeline>
  )
}

export default EmploymentTypeField
